











import Vue, { PropType } from 'vue';
import Button from '../Button/Button.vue';
import BaseInput from '../../forms/bases/BaseInput/BaseInput.vue';
import { ButtonTypes, ButtonSizes } from '../Button/Button.types';

export default Vue.extend({
  name: 'InputButton',
  props: {
    disabled: Boolean,
    rounded: Boolean,
    type: String as PropType<ButtonTypes>,
    size: String as PropType<ButtonSizes>,
    value: String,
    placeholder: String,
  },
  components: {
    Button,
    BaseInput,
  },
  data() {
    return {
      editing: false,
    };
  },
  methods: {
    onFinishEditing(value: string) {
      this.editing = false;
      this.$emit('input', value);
    },
    onEnter() {
      this.editing = true;
      this.$nextTick(() => {
        const $el = (this.$refs.input as Vue).$el as HTMLInputElement;
        $el.focus();
        $el.select();
      });
    },
  },
});
